import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneCaricaDocumentoModelloIntrastatStep2Component } from './conservazione-carica-documento-modello-intrastat-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-modello-intrastat-step2', {
            url: '/conservazione-carica-modello-intrastat',
            ncyBreadcrumb: {
                label: 'Carica Modello Intrastat',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-modello-intrastat-step2 flex="100"></conservazione-carica-documento-modello-intrastat-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoModelloIntrastatStep2Module: string = ng
    .module('conservazione-carica-documento-modello-intrastat-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoModelloIntrastatStep2', ConservazioneCaricaDocumentoModelloIntrastatStep2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-modello-intrastat-step2/conservazione-carica-documento-modello-intrastat-step2.module.ts